import Metric, * as metric from './Metric';

export type JSONMetrics = {
  num_units: metric.JSONMetric[];
};

type Metrics = Metric[];

function fromJSON(jsonMetrics: JSONMetrics): Metrics {
  return (jsonMetrics.num_units || []).map(metric.fromJSON);
}

export default Metrics;
export { fromJSON };
